// @ts-ignore
import type * as SchemaTypes from '../../../../graphql/api/index';

import { gql } from 'graphql-tag';
export const OrderedListItemFragmentDoc = gql`
    fragment orderedListItem on OrderedListItem {
  __typename
  title
  description
}
    `;